import { configureStore,combineReducers } from '@reduxjs/toolkit'
import userReducer from './userReducer'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // 默认使用 localStorage

// 持久化配置
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'], // 需要持久化的 reducer 名称
  version: 1, // 数据版本，用于迁移管理
};

// 根 reducer
const rootReducer = combineReducers({
  user: userReducer,
});
// 创建持久化 reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 创建 store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
export type RootType = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export default store;
